import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsGetReq extends EntityClaim {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_claim_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
